import React, { useEffect } from 'react';
import './Productcard.css'; // Optional for custom styles
import { Link } from 'react-router-dom';

const Productcard = (props) => {

    const truncateTitle = (title, maxLength = 35) => {
        if (!title) return '';
        return title.length > maxLength ? title.substring(0, maxLength).trim() + '...' : title;
    };

  const delPro = () => {
    const confirmDelete = window.confirm("Are you sure you want to delete this product?");
    if (!confirmDelete) return; // Stop if user clicks Cancel

    fetch(`https://pentadeco.in/api/delpro/${props.id}`)
      .then(res => res.json())
      .then(data => {
        if (!data.success) {
          alert("Failed to delete product");
          console.log(data);
        } else {
          alert("Product deleted successfully");
          // Optional: refresh or remove product from UI here
        }
      })
      .catch(err => console.log('Error occurred while deleting the product', err));
  };
  
  return (
    <div className="card rounded-brand-lg overflow-hidden">
      <Link to={`/${props.id}/${props.name.toLowerCase().replaceAll(' ', '-')}`} className="nav-link">
        <img src={props.coverimg} className="card-img-top p-2 rounded-brand-lg" alt="Coffee Mug" style={{aspectRatio: '1/1', objectFit: 'cover'}} />
      </Link>

      <div className="card-body p-2">
        <Link to={`/${props.id}/${props.name.toLowerCase().replaceAll(' ', '-')}`} className="nav-link">
          <p className="text-muted mb-1 body-font-bold fs-eesm text-uppercase">
            {props?.category}
          </p>
          <h5 className="card-title fs-6 mb-3">
            {truncateTitle(props.name)}
          </h5>
          <div className="d-flex align-items-end justify-content-between">
              <p className="body-font-black product-card-price mb-0 fs-4"><sup className='fs-esm body-font-bold'>₹</sup>{props.price}</p>
              <button className="btn btn-brand-secondary view-details-btn fs-sm text-nowrap rounded-pill px-3">
                  View Details
              </button>
          </div>
        </Link>
        {
          props.admin && (
            <div className="d-flex justify-content-between mt-3">
              <p className="mb-0 btn btn-danger fs-eesm text-nowrap rounded-pill px-3" onClick={delPro}>
                  Delete
              </p>
              <a href={`/dashboard/editproduct/${props.id}`} className="btn btn-primary fs-eesm text-nowrap rounded-pill px-3">
                  Edit
              </a>
            </div>
          )
        }
      </div>
    </div>
  );
};

export default Productcard;
